import {
  type FancyBody,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

// The 200 body varies by caller role, so it is typed as a union of an open
// object, a license-summary array and the per-license array console agents
// get. `count` exists only on the last; `ReadonlyArray` drops the object and
// also matches `readonly` arrays should the generator emit them.
export type LicensesResponse = Extract<
  FancyOk<fancyOperations['getSchoolLicensesR']>,
  ReadonlyArray<{count: number}>
>

/**
 * One license as `getSchoolLicensesR` returns it to a console agent. Only its
 * dates change type.
 */
export type LicenseT = Omit<LicensesResponse[number], 'startsAt' | 'expiresAt'> & {
  startsAt: Date
  expiresAt: Date
}

// `Date` for the date pickers; `postSchoolLicense` converts them to ISO strings.
export type LicensePostT = Omit<
  FancyBody<fancyOperations['postSchoolLicensesR']>,
  'startsAt' | 'expiresAt'
> & {
  startsAt: Date
  expiresAt: Date
}

export const fromOpenApiLicenses = (response: LicensesResponse): Array<LicenseT> =>
  response.map(license => ({
    ...license,
    startsAt: new Date(license.startsAt),
    expiresAt: new Date(license.expiresAt)
  }))
